import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import MeetingPage from "./pages/MeetingPage";
import ReservePage from "./pages/ReservePage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  background: "#0A1128",
                  color: "#F4F1EB",
                  border: "1px solid rgba(197,160,89,0.35)",
                  fontFamily: "Outfit, sans-serif",
                },
              }}
            />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/marcar-reuniao" element={<MeetingPage />} />
              <Route path="/book-meeting" element={<MeetingPage />} />
              <Route path="/reservar/:houseId" element={<ReservePage />} />
              <Route path="/book/:houseId" element={<ReservePage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/reserva/sucesso" element={<PaymentSuccessPage />} />
              <Route path="/reservation/success" element={<PaymentSuccessPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
